import axios from "axios";
import { FREERADIUS_API_BASE_URL } from "@/config";

const client = axios.create({
  baseURL: FREERADIUS_API_BASE_URL,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

/**
 * freeradius-api answers business failures with `{ success: false, error,
 * error_code }` on a 2xx, and transport/validation failures with a non-2xx that
 * carries the same shape. Normalise both into one object so callers only ever
 * branch on `success`.
 */
function normalize(error) {
  const data = error?.response?.data;
  if (data && typeof data === "object" && "success" in data) {
    return data;
  }
  return {
    success: false,
    error: error?.message || "network error",
    error_code: "NETWORK_ERROR",
  };
}

/**
 * Asks the API to SMS an OTP to the given number.
 * @param {string} mobileNumber Thai mobile number, any formatting
 * @returns {Promise<{success: boolean, reference_code?: string, error?: string, error_code?: string, cooldown?: number}>}
 */
export async function requestOtp(mobileNumber) {
  try {
    const { data } = await client.post("/wifi/request-otp", {
      mobile_number: mobileNumber,
    });
    return data;
  } catch (error) {
    return normalize(error);
  }
}

/**
 * Verifies the OTP. On success the API has already provisioned the RADIUS user
 * and returns the credentials to submit to the Mikrotik login form.
 * @returns {Promise<{success: boolean, username?: string, password?: string, error?: string, error_code?: string}>}
 */
export async function verifyOtp(mobileNumber, otpCode) {
  try {
    const { data } = await client.post("/wifi/verify-otp", {
      mobile_number: mobileNumber,
      otp_code: otpCode,
    });
    return data;
  } catch (error) {
    return normalize(error);
  }
}
